"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.i18n = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _ar = _interopRequireDefault(require("./ar/ar.json"));
var _es = _interopRequireDefault(require("./es/es.json"));
var _en_GB = _interopRequireDefault(require("./en_GB/en_GB.json"));
var _en_AU = _interopRequireDefault(require("./en_AU/en_AU.json"));
var _en_US = _interopRequireDefault(require("./en_US/en_US.json"));
var _fr = _interopRequireDefault(require("./fr/fr.json"));
var _fr_CA = _interopRequireDefault(require("./fr_CA/fr_CA.json"));
var i18n = {
  ar: (0, _extends2.default)({}, _ar.default),
  en_US: (0, _extends2.default)({}, _en_US.default),
  en_GB: (0, _extends2.default)({}, _en_GB.default),
  en_AU: (0, _extends2.default)({}, _en_AU.default),
  es: (0, _extends2.default)({}, _es.default),
  fr: (0, _extends2.default)({}, _fr.default),
  fr_CA: (0, _extends2.default)({}, _fr_CA.default)
};
exports.i18n = i18n;